import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { injectVideoLogoSuccessfully, setEventEmitter } from '../../../pageLayouts/eventEmitters/eventEmitters.utils';
import { Link } from '../../../../partials/link/Link';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { AnimationDirection, AnimationDirectionType } from '../menuAnimations.util';
import { useTheme } from '../../../../../theming/useTheme';
import { reducedLogoHeightFactor } from '../header.utils';

export interface InjectedVideoLogoApiProps {
    videoPath: string;
}

export interface InjectedVideoLogoDataProps {
    href: string;
    menuAnimation?: AnimationDirectionType;
    reduceHeightAnimationDuration?: number;
    firstRowHeightInSmallScreen: number;
    firstRowHeightInMediumScreen: number;
    firstRowHeightInLargeScreen: number;
}

type InjectedVideoLogoProps = InjectedVideoLogoApiProps & InjectedVideoLogoDataProps;

const embeddedVideoLogoPaddingInPx = 20;

const getInjectedVideoLogoStyle = (reduceHeightAnimationDuration: number, menuAnimation: AnimationDirectionType, baseUnit: number, firstRowHeightInLargeScreen: number, firstRowHeightInMediumScreen: number, firstRowHeightInSmallScreen: number) => {
  return StyleSheet.create({
    wrapper: {
      [MEDIA_BREAKPOINTS.large]: {
        height: menuAnimation === AnimationDirection.UP ? `${baseUnit * firstRowHeightInLargeScreen * reducedLogoHeightFactor}px` : `${baseUnit * firstRowHeightInLargeScreen}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        height: `${baseUnit * firstRowHeightInMediumScreen}px`,
      },
      [MEDIA_BREAKPOINTS.small]: {
        height: `${baseUnit * firstRowHeightInSmallScreen}px`,
      },
      transition: `${reduceHeightAnimationDuration}ms`,
    },
    video: {
      height: '100%',
      alignItems: 'center',
      display: 'inline-flex',
      margin: `0 -${embeddedVideoLogoPaddingInPx}px`,
    },
    source: {
      height: '100%',
    },
  });
};

export const VideoLogo: React.FunctionComponent<InjectedVideoLogoProps> = props => {
  const { baseUnit } = useTheme();
  const { videoPath, href, reduceHeightAnimationDuration = 0, menuAnimation = AnimationDirection.NONE, firstRowHeightInLargeScreen, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen } = props;
  const style = getInjectedVideoLogoStyle(reduceHeightAnimationDuration, menuAnimation, baseUnit, firstRowHeightInLargeScreen, firstRowHeightInMediumScreen, firstRowHeightInSmallScreen);

  React.useEffect(() => {
    setEventEmitter(injectVideoLogoSuccessfully, (callback: Function) => callback());
  }, [videoPath]);

  return (
    <Link className={css(style.wrapper)} href={href}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video className={css(style.video)} loop autoPlay muted>
        <source className={css(style.source)} src={videoPath} type="video/mp4" />
      </video>
    </Link>
  );
};
